import "core-js/modules/es.array.includes.js";
import "core-js/modules/es.function.name.js";
import "core-js/modules/es.object.to-string.js";
import "core-js/modules/es.regexp.exec.js";
import "core-js/modules/es.string.includes.js";
import "core-js/modules/es.string.iterator.js";
import "core-js/modules/es.string.search.js";
import "core-js/modules/web.dom-collections.iterator.js";
import "core-js/modules/web.url-search-params.js";
import { defineComponent as _defineComponent } from 'vue';
import BAlert from '~/components/general/BAlert.vue';
import BHeader from '~/components/general/BHeader.vue';
import BAuth from '~/components/general/Auth/BAuth.vue';
import { changeLayoutStyles } from '~/utils/utils';
import { useAppStore } from '~/store/app';
export default /*#__PURE__*/_defineComponent({
  __name: 'default',
  setup: function setup(__props) {
    var appStore = useAppStore();
    var route = useRoute();
    var bus = useNuxtEventBus();
    var config = reactive({
      header: true,
      layoutStyle: null,
      foreColor: null,
      backColor: null
    });
    var foreColor = ref(null);
    var backColor = ref(null);
    var organizer = ref(null);
    var getAuthDialog = computed(function () {
      return appStore.getAuthDialog;
    });
    var isPublishScreen = computed(function () {
      var _route$name;
      return route === null || route === void 0 ? void 0 : (_route$name = route.name) === null || _route$name === void 0 ? void 0 : _route$name.includes('tenant-organizer-organizerName-event-id-publish');
    });
    function applyOrganizerColors(fetchedOrganizer) {
      var _organizer$value;
      organizer.value = fetchedOrganizer;
      var branding = (_organizer$value = organizer.value) === null || _organizer$value === void 0 ? void 0 : _organizer$value.branding;
      if (branding) {
        var _foreColor$value, _backColor$value;
        // make sure that widget styles are always applied
        var primary = (_foreColor$value = foreColor.value) !== null && _foreColor$value !== void 0 ? _foreColor$value : branding === null || branding === void 0 ? void 0 : branding.primary;
        var gray = (_backColor$value = backColor.value) !== null && _backColor$value !== void 0 ? _backColor$value : branding === null || branding === void 0 ? void 0 : branding.gray;
        config.layoutStyle = changeLayoutStyles(primary, gray, branding === null || branding === void 0 ? void 0 : branding.highlightSuccess, branding === null || branding === void 0 ? void 0 : branding.highlightInfo, branding === null || branding === void 0 ? void 0 : branding.highlightWarning, branding === null || branding === void 0 ? void 0 : branding.highlightError);
      }
    }
    function closeAuthDialog() {
      appStore.setAuthDialog(false);
      appStore.setEnableGuestLogin(false);
      var body = document.body;
      body.setAttribute('style', '');
    }
    function openLogin() {
      appStore.setAuthDialog(true);
      var body = document.body;
      body.setAttribute('style', 'height: 100vh; overflow-y: hidden');
    }

    // Composition-API equivalent of the old created() hook — runs before this
    // setup()'s own state would have been processed as `data()`, so both
    // listeners are attached before either event could possibly be emitted.
    bus.$on('closeForgotPasswordForm', closeAuthDialog);
    bus.$on('organizerFetched', applyOrganizerColors);
    onMounted(function () {
      var urlParams = new URLSearchParams(window.location.search);
      var header = urlParams.get('header');
      if (header && header === 'false') {
        config.header = false;
      }
      foreColor.value = urlParams.get('foreColor');
      backColor.value = urlParams.get('backColor');
      config.layoutStyle = changeLayoutStyles(foreColor.value, backColor.value);
    });
    onBeforeUnmount(function () {
      bus.$off('closeForgotPasswordForm');
      bus.$off('organizerFetched');
    });
    return {
      __sfc: true,
      appStore: appStore,
      route: route,
      bus: bus,
      config: config,
      foreColor: foreColor,
      backColor: backColor,
      organizer: organizer,
      getAuthDialog: getAuthDialog,
      isPublishScreen: isPublishScreen,
      applyOrganizerColors: applyOrganizerColors,
      closeAuthDialog: closeAuthDialog,
      openLogin: openLogin,
      BAlert: BAlert,
      BHeader: BHeader,
      BAuth: BAuth
    };
  }
});